module.exports = __webpack_public_path__ + "img/flags/BT.e0697c7.png";